import { render, staticRenderFns } from "./DentalProResolver.vue?vue&type=template&id=55f327f1&scoped=true"
import script from "./DentalProResolver.vue?vue&type=script&lang=ts"
export * from "./DentalProResolver.vue?vue&type=script&lang=ts"
import style0 from "./DentalProResolver.vue?vue&type=style&index=0&id=55f327f1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f327f1",
  null
  
)

export default component.exports